import {
  AddAttributionDetailsInput,
  PartnerConnector,
} from '@generated/gql/graphql';
import { INTRODUCED_BY } from '@src/types/attribution';
import { YourDetailsFormValues } from '@src/types/yourDetails';

const parseAttributionInput = (
  values: YourDetailsFormValues,
  connectors?: Nullable<PartnerConnector[]>
): Nullable<AddAttributionDetailsInput> => {
  const { introducedBy, customerReferral, partnerReferral, connectorReferral } =
    values;

  if (introducedBy === INTRODUCED_BY.NONE) {
    return null;
  }

  switch (introducedBy) {
    case INTRODUCED_BY.CUSTOMER: {
      if (!customerReferral) {
        return null;
      }

      return {
        referrer: {
          customerManual: {
            accountNumber: customerReferral,
          },
        },
      };
    }

    case INTRODUCED_BY.PARTNER: {
      if (!partnerReferral) {
        return null;
      }

      return {
        referrer: {
          partnerManual: {
            positionId: partnerReferral,
          },
        },
      };
    }

    case INTRODUCED_BY.CONNECTOR: {
      if (!connectorReferral) {
        return null;
      }

      const connector = connectors?.find((c) => c.id === connectorReferral);

      if (!connector) {
        return {
          referrer: {
            connector: {
              id: connectorReferral,
              shortId: connectorReferral,
            },
          },
        };
      }

      return {
        referrer: {
          connector: {
            id: connector.id,
            shortId: connector.shortId,
          },
        },
      };
    }

    default: {
      return null;
    }
  }
};

export { parseAttributionInput };
